import React from "react";
import { Link } from "react-router-dom";
import Icon from "../Icon";
import { HeroApp } from "../Mockups";
import PartnersCarousel from "../PartnersCarousel";
import { REGISTER_URL } from "../landingData";

const HeroSection = () => (
    <header className="clk-hero clk-grid-bg" id="top">
        <div className="clk-hero-glow g1" aria-hidden="true" />
        <div className="clk-hero-glow g2" aria-hidden="true" />
        <div className="clk-hero-glow g3" aria-hidden="true" />

        <div className="clk-container clk-hero-inner">
            <div className="clk-hero-copy">
                <p className="clk-hero-badge">
                    <span className="clk-dot" aria-hidden="true" />
                    Customer support ticketing
                </p>
                <h1>
                    Run a busy support queue.{" "}
                    <span className="clk-grad-text">Without the chaos.</span>
                </h1>
                <p className="clk-hero-sub">
                    From the first email to the last resolution, Claritick puts every channel on one live
                    screen so nothing slips and your team keeps full context on every request.
                </p>
                <div className="clk-hero-actions">
                    <a className="clk-btn clk-btn-primary clk-btn-lg" href={REGISTER_URL}>
                        Start free trial
                    </a>
                    <Link className="clk-btn clk-btn-secondary clk-btn-lg" to="/how-it-works">
                        See how it works <Icon name="arrow" size={18} className="clk-arrow" />
                    </Link>
                </div>
            </div>
            <HeroApp />
        </div>

        <PartnersCarousel />
    </header>
);

export default HeroSection;

